import React, { Component } from 'react';
import $ from 'jquery';
import Constants from '../constants';
import data from '../data/map-data';
import MapSettings from '../data/map-settings';
class RegionMap extends Component {

    renderMap() {
        $.fn.vectorMap('addMap', 'uk_regions_merc', data);
        this.map = $("#map").vectorMap(MapSettings);
    }

    componentDidMount() {
        document.addEventListener('click-uk-map', this.onRegionChange.bind(this), true);
        $(document).ready(() => {
            this.renderMap();
            $('.map-uk').fadeIn(350);
        });
    }
    
    componentWillUnmount() {
        $('.map-uk').fadeOut(200);
        this.map.remove("#map") // Remove/destroy the map
        this.map = null;
        document.removeEventListener('click-uk-map', this.onRegionChange.bind(this), true);
        $(window).off("resize");
    }

    onRegionChange(e) {
        if (e.type === 'click-uk-map') {
            this.props.selectRegion(data.paths[e.detail.code].name);
        }
    }

    onCloseInnerPanel(){
       this.props.closeRegion(this.props.currentRegion);
       this.props.closeLocation(this.props.currentLocation);
    }

    render(){
        return(
            <div className="medium-6 columns component-map-wrapper hide-only-mobile">
                <div className="component-map" id={this.props.currentRegion}>
                <div id="map" className="map map-uk"></div>
            </div>
        </div> 
        )
    }
}

export default RegionMap;


// WEBPACK FOOTER //
// ./src/js/components/RegionMap.js